import { render, staticRenderFns } from "./LanguageSwitcherComponent.vue?vue&type=template&id=7b398650&"
import script from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports